import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'
import { Row, Col, message } from 'antd'
import AdminLayout from 'components/elements/AdminLayout'
import SectionContent from 'components/elements/SectionContent'
import SexesCards from './SexesCards'
import Item from './Item'

import {
  genderActions
} from 'actions'

class Users extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleCreateButtonOnClick = this.handleCreateButtonOnClick.bind(this)
    this.handleTableOnChange = this.handleTableOnChange.bind(this)
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    // this.chooseSendReminders = this.chooseSendReminders.bind(this)
  }

  componentDidMount() {
    this.fetch()
  }

  componentDidUpdate(previousProps) {
    if (previousProps.isFetchItemsLoading && this.props.fetchItemsError) {
      message.error(this.props.fetchItemsError)
    }
  }

  fetch() {
    genderActions.fetch()
  }

  handleCreateButtonOnClick(e) {
    e.preventDefault()
    this.props.history.push(createPath)
  }

  async handleTableOnChange(pagination, filters, sorter) {
    const { columnKey, field, order } = sorter
    await this.props.changeTable({
      pagination,
      filters,
      sorter: {
        columnKey,
        field,
        order,
      },
    })
    this.fetch()
  }

  handleOnSelect(genders) {
    if(genders){
      this.props.history.push(`/admin/sexes/${genders.id}`)
    }
  }

  handleCreate() {
    this.props.history.push(`/admin/sexes/new`)
  }

  async handleSearchOnClick() {
    await this.props.searchTable({ isSearching: true })
    await this.props.changeTable({})
    this.fetch()
  }

  async handleSearchOnCancel(e) {
    e.preventDefault()
    await this.props.editSearch({ search: null })
    await this.props.searchTable({ isSearching: false })
    await this.props.changeTable({})
    this.fetch()
  }

  render() {
    
    return (
      <div>
        <AdminLayout>
          <SectionContent noPadding noMargin title='Sexes'>
          <Switch>
            <Route path='/admin/sexes' render={()=>
              <Row style={{height: '100%'}}>
                <Col xs={24} lg={8}>
                  <SexesCards
                    dataSource={this.props.genders || []}
                    onSelect={this.handleOnSelect}
                    onCreate={this.handleCreate}
                  />
                </Col>
                <Col xs={24} lg={16}>
                  <Route path='/admin/sexes/:id'>
                    <Item />
                  </Route>
                </Col>
              </Row>
            }/>
          </Switch>
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

export default withRouter(connect((state)=>(state))(Users))
